var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCirclePlayIcon = function SvgCirclePlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M43.25 22c0 11.736-9.514 21.25-21.25 21.25S.75 33.736.75 22 10.264.75 22 .75 43.25 10.264 43.25 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M43.25 22c0 11.736-9.514 21.25-21.25 21.25S.75 33.736.75 22 10.264.75 22 .75 43.25 10.264 43.25 22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.317 10.933a.86.86 0 0 1 .877.032l16.041 10.312a.86.86 0 0 1 0 1.446L17.194 33.035a.86.86 0 0 1-1.324-.722V11.686a.86.86 0 0 1 .447-.754",
    clipRule: "evenodd"
  })));
};
export default SvgCirclePlayIcon;